var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-object-card__rtsp"},[(_vm.isReady)?_c('hls-player',{attrs:{"url":_vm.url}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }